import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const AuthorBio = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <SectionHeading title="About the Author" subtitle="Biography" />
      <div className="space-y-8">
        {[
          {
            heading: "A Panoramic Vision",
            text: "Andrei Marius Ciomîrtan is the mind behind one of the most ambitious science fiction chronicles in recent memory. His work spans five centuries of human history — real and imagined — weaving together quantum physics, geopolitical collapse, ecological redemption, and the philosophy of interstellar civilizations."
          },
          {
            heading: "The Human Beneath the Epic",
            text: "What distinguishes Ciomîrtan's writing is his insistence on the human scale. The grand terraforming of Venus is told through the eyes of a woman who mourns the old planet's clouds. The launch of humanity's first interstellar ship is witnessed by a mother and daughter in a cold corridor. Statistics become teachers, farmers, engineers — people with names."
          },
          {
            heading: "The Chapter on Earth",
            text: "By the author's own admission, the chapter on Earth was written in shame. The deaths are named. The failures are counted. The 7.4 billion people lost between Earth's 2058 peak and its 2501 population of 3 billion are not abstractions — they are the cost of a civilization that knew and chose not to act in time."
          },
          {
            heading: "The Closing Torch",
            text: "Yet the book insists, page after page, that the same species capable of all that destruction is also capable of turning Venus into paradise, of building communities at -235°C on Triton, of launching a ship toward another star and dimming the lights of eight worlds in unison to watch it go. Close this book not as someone who has finished reading about a story — but as someone who has been handed a torch."
          }
        ].map((section, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-brand-surface border border-white/5 rounded-2xl p-8"
          >
            <h3 className="text-brand-accent font-semibold text-sm uppercase tracking-widest mb-4">{section.heading}</h3>
            <p className="text-gray-300 leading-relaxed">{section.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default AuthorBio;